import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "篩檢年份",
    isNumber: true,
    isSum: true,
  },
];

export const DoctorDecide = {
  label: "醫師判讀",
  key: "DoctorDecide",
  path: "AtriumFibrillation/DoctorDecide",
  api: "TCS_V_HeartSS01",
  render: (options) => <Diagram.AtriumFibrillation.DoctorDecide {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "醫師報告",
      field: "醫師報告",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
